import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/commandDeckTheme.css";
import "@/utils/adminAxios"; // registers the global admin-token request interceptor before render
import { startVersionCheck } from "@/utils/versionCheck";
import App from "@/App";

startVersionCheck(); // reload stale tabs onto a freshly-deployed bundle

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
